var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2279 3.68377C16.0918 3.27543 15.7097 3 15.2792 3H8.72076C8.29033 3 7.90819 3.27543 7.77208 3.68377L7.22792 5.31623C7.09181 5.72457 6.70967 6 6.27924 6H4C2.89543 6 2 6.89543 2 8V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8C22 6.89543 21.1046 6 20 6H17.7208C17.2903 6 16.9082 5.72457 16.7721 5.31623L16.2279 3.68377ZM10.4809 17.1893C9.00971 15.9955 7 14.0234 7 12.1588C7 9.04374 9.75008 7.88075 12 10.2871C14.2499 7.88075 17 9.04374 17 12.1587C17 14.0234 14.9903 15.9955 13.5191 17.1893C12.8531 17.7298 12.5201 18 12 18C11.4799 18 11.1469 17.7298 10.4809 17.1893ZM19 10C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8C18.4477 8 18 8.44772 18 9C18 9.55228 18.4477 10 19 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWedding);
export default __webpack_public_path__ + "static/media/camera-wedding.e62ff515bbf4b60e5f3c967920202ec9.svg";
export { ForwardRef as ReactComponent };